module.exports = __webpack_public_path__ + "assets/Segment6.3ef140ed935516bdfb20feed395c1912.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Segment6.gmt
// module id = 991
// module chunks = 0